import { Link } from 'react-router-dom';
import { ArrowRight, ShieldAlert } from 'lucide-react';
import Metadata from '../components/Metadata';
import PageHero from '../components/PageHero';
import { assets, pageMeta } from '../data/siteData';
import { assetUrl } from '../lib/media';

export default function ForbiddenPage() {
  return (
    <>
      <Metadata
        title={pageMeta.forbidden.title}
        description={pageMeta.forbidden.description}
        image={assetUrl(pageMeta.forbidden.ogImage, 1200)}
        path="/403"
        noindex
      />

      <PageHero
        eyebrow="403"
        title="Adgang nægtet"
        description="Du har ikke adgang til denne side. Brug en af knapperne herunder for at gå tilbage til hjemmesiden eller kontakte RS Byg direkte."
        image={assets.detail}
        primaryAction={{ label: 'Til forsiden', to: '/' }}
        secondaryAction={{ label: 'Kontakt os', to: '/kontakt' }}
      />

      <section className="bg-white py-16">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-4 sm:grid-cols-2">
            <div className="border border-brand-gray-200 bg-brand-gray-50 p-6">
              <ShieldAlert className="h-10 w-10 text-brand-orange" />
              <h2 className="mt-4 font-display text-2xl font-bold text-brand-black">Tilbage til forsiden</h2>
              <p className="mt-3 text-sm leading-7 text-brand-gray-600">Du kan altid gå tilbage til hjemmesiden og finde den information, du havde brug for.</p>
              <Link to="/" className="mt-5 inline-flex items-center justify-center bg-brand-black px-5 py-3 text-xs font-bold uppercase tracking-[0.18em] text-white transition-colors hover:bg-brand-orange">
                Gå til forsiden
                <ArrowRight className="ml-3 h-4 w-4" />
              </Link>
            </div>

            <div className="border border-brand-gray-200 bg-brand-gray-50 p-6">
              <ShieldAlert className="h-10 w-10 text-brand-orange" />
              <h2 className="mt-4 font-display text-2xl font-bold text-brand-black">Har du brug for hjælp?</h2>
              <p className="mt-3 text-sm leading-7 text-brand-gray-600">Kontakt RS Byg, hvis du er havnet her ved en fejl eller gerne vil have hjælp til at finde den rigtige side.</p>
              <Link to="/kontakt" className="mt-5 inline-flex items-center justify-center border border-brand-gray-200 px-5 py-3 text-xs font-bold uppercase tracking-[0.18em] text-brand-black transition-colors hover:border-brand-orange hover:text-brand-orange">
                Gå til kontakt
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
